import { useRef } from 'react';
import { createGamePropertiesWithRules } from '@wareena/grid-battles-engine/dto/gameProperties';
import { useGameContext } from './GameContext.js';
import getRequestOrders from '@wareena/grid-battles-engine/agent/agentActor/getRequestOrders';
import { runRequests, } from '@wareena/grid-battles-engine/agent/agentActor/runRequests';
export default function useAgent(initialAgentRequests, agentPlayer, stateMachine, strategyIngredients) {
    const isAgentPaused = useRef(false);
    const isAgentTakingMove = useRef(false);
    const agentRequests = useRef(structuredClone(initialAgentRequests));
    const { game, scenario, hexProperties, rules } = useGameContext();
    const agentRequestsContainer = {
        takeNextAgentRequest: () => {
            return agentRequests.current.shift();
        },
        getAgentRequests: () => {
            return [...agentRequests.current];
        },
        getCount: () => {
            return agentRequests.current.length;
        },
        setRequests(requests) {
            agentRequests.current = requests;
        },
    };
    function shouldAgentTakeATurn() {
        if (!isAgentTakingMove.current &&
            game.state.activeSide === agentPlayer.side &&
            (game.state.stateName === 'selectingForActivation' ||
                agentRequestsContainer.getCount() > 0)) {
            return true;
        }
        return false;
    }
    const gameProperties = createGamePropertiesWithRules(game, scenario, hexProperties, rules);
    function takeTurn() {
        isAgentTakingMove.current = true;
        if (agentRequestsContainer.getCount() === 0) {
            const requests = getRequestOrders(gameProperties, agentPlayer.side, agentPlayer.id, strategyIngredients);
            agentRequestsContainer.setRequests(requests);
        }
        runRequests(agentRequestsContainer, {
            intervalInMs: 500,
            gameState: game.state,
            stateMachine,
            isAgentPaused: () => isAgentPaused.current,
            setIsAgentTakingMove: (isTakingMove) => (isAgentTakingMove.current = isTakingMove),
        });
    }
    if (shouldAgentTakeATurn()) {
        takeTurn();
    }
    return {
        setIsAgentPaused: (isPaused) => (isAgentPaused.current = isPaused),
        agentRequestsContainer,
    };
}
